<div class="lineout row settings-persona-item" data-ref="root">
	<img class="shadow" data-ref="picture">
	<div class="list settings-persona-item-main">
		<div class="row-compact">
			<h6 data-ref="name"></h6>
			<button class="lineout" data-ref="edit">edit</button>
			<button class="lineout" data-ref="delete">delete</button>
		</div>
		<div data-ref="description"></div>
	</div>
</div>
